import React from 'react'
import { Dropdown, NavDropdown } from 'react-bootstrap'
import { I18n } from 'react-redux-i18n'
import { FaChevronDown } from 'react-icons/fa6'

const PaymentMethodSelector = ({
	selectedPaymentMethod,
	paymentMethods = [],
	onSelectPaymentMethod
}) => {
	return (
		<div className="selectPaymentMethod">
			<span className='titlePm'>{I18n.t('cue.Payment_Method')}</span>
			<NavDropdown
				id="paymentMethod-dropdown"
				title={
					<div>
						<div className="d-flex align-items-center justify-content-between mt-2" style={{ backgroundColor: '#24272E', padding: '15px', borderRadius: '5px', color: '#98A2B3', fontSize: '16px', fontWeight: '500' }}>
							<div className="d-flex align-items-center">
								<div id="creditcard" style={{ width: '40px', height: '25px', backgroundSize: 'contain', backgroundRepeat: 'no-repeat' }} className={`${selectedPaymentMethod?.cardType ? selectedPaymentMethod?.cardType : 'stripe'} mr-3`}>
								</div>
								<div className="d-flex flex-column">
									<span style={{ fontSize: '16px', lineHeight: '1' }}>****{selectedPaymentMethod?.last4}</span>
									<span style={{ fontSize: '12px' }}>{
										selectedPaymentMethod?.email ?
											selectedPaymentMethod?.email :
											selectedPaymentMethod?.expMonth && selectedPaymentMethod?.expireYear ? 
												`${I18n.t('billingUsage.expires')} ${selectedPaymentMethod?.expMonth}/${selectedPaymentMethod?.expireYear}` : 
												'Stripe'
									}</span>
								</div>
							</div>
							<FaChevronDown style={{ float: 'right' }} />
						</div>
					</div>
				}
			>
				{paymentMethods?.map(paymentMethod => (
					<Dropdown.Item
						key={paymentMethod.paymentId}
						className="d-flex align-items-center payment-method-item-dropdown"
						onClick={() => onSelectPaymentMethod(paymentMethod)}
					>
						<div id="creditcard" style={{ width: '40px', height: '25px', backgroundSize: 'contain', backgroundRepeat: 'no-repeat' }} className={`${paymentMethod.cardType ? paymentMethod?.cardType : 'stripe'} mr-3`}>
						</div>
						<div className="d-flex flex-column">
							<span style={{ fontSize: '16px', lineHeight: '1' }}>****{paymentMethod.last4}</span>
							<span style={{ fontSize: '12px' }}>
								{paymentMethod.email ? paymentMethod.email : paymentMethod?.expMonth && paymentMethod?.expireYear ? `${I18n.t('billingUsage.expires')} ${paymentMethod.expMonth}/${paymentMethod.expireYear}` : 'Stripe'}
							</span>
						</div>
					</Dropdown.Item>
				))}
			</NavDropdown>
		</div>
	)
}

export default PaymentMethodSelector
